import { styled } from "goober";
import { ClickButton } from "./ClickButton";

export const HeadingDropdownOpener = styled(ClickButton)`
  display: flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  padding: 4px 8px;
  background: var(--alpha4);
  border-radius: 9999px;

  &:hover {
    background: var(--alpha8);
  }
`;
